import {defineQuery} from 'next-sanity';
import type {Slug} from 'sanity';
import type {LinkableDocumentTypes} from 'utils';

export const LINK_REFERENCES_QUERY = defineQuery(`
	*[(_type == "page" || _type == "frontpage") && _id == $id][0]{
		_id,
		_type,
		slug,
	}
`);

export type LinkReferencesQueryResult = {
	_id: string;
	_type: LinkableDocumentTypes;
	slug?: Slug;
} | null;
